"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {
  Component,
  Mixins,
  PropSync
} from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
let StartupByShopBtn = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.skip_check = false;
  }
  checkVersion(item) {
    return __async(this, null, function* () {
      try {
        let version_response = yield API.get(`api://base.local/update/version`);
        let _version = version_response.data.version;
        if (_version === "6.8.2.7") {
          let realVersion = version_response.data.os.version.split("(")[0].trim();
          if (realVersion === "0" || realVersion === "7") {
            let response = yield API.get(`api://base.auth/api/v9/shop/${item.shopOldId}/browser_core`);
            if (response.data.code === "chrome" && response.data.version === "122") {
              try {
                try {
                  yield API.get(`api://base.local/storages/session/checkOpenWin7`);
                } catch (error) {
                  yield UiConfirm.warnconfirm(`${this.$t("main.win7_tips_message")}`, this.$t("main.win7_tips_title"), {
                    confirmButtonText: this.$t("main.win7_tips_confirm"),
                    customClass: "new-confirm-box",
                    showClose: false,
                    cancelButtonText: this.$t("headertoolbar.cancel")
                  });
                }
                yield API.put(`api://base.local/storages/session/checkOpenWin7`, {
                  "message": "no.show.win7",
                  "model": "no.show.win7"
                });
                try {
                  yield API.post(`api://base.auth/api/v9/shop/${item.shopOldId}/browser_core_auto_downgrade`);
                } catch (error) {
                  return false;
                }
                return false;
              } catch (error) {
                return true;
              }
            }
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    });
  }
  start(item) {
    return __async(this, null, function* () {
      var _a;
      try {
        const flag = yield this.checkVersion(item);
        if (flag === true) {
          return;
        }
        this._row.btnState = "loading";
        item.account = (_a = this.$session) == null ? void 0 : _a.account;
        this.launcher(item);
      } catch (error) {
      }
    });
  }
  closeShop(item) {
    return __async(this, null, function* () {
      try {
        yield API.delete(`api://base.local/v2/dynamic-browsers/${item.shopOldId}`);
        item.btnState = "ready";
      } catch (error) {
        item.btnState = "ready";
      }
    });
  }
  toRenew(item) {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth.pro/v1/virtual-desktops/${item.vd.id}`
        );
        this.$router.push({
          name: "payment",
          query: {
            style: "renew"
          },
          params: {
            item: JSON.stringify(response.data)
          }
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  toBuy(item) {
    return __async(this, null, function* () {
      let shop_id = item.shopOldId;
      this.$router.push({
        name: "payment",
        query: { style: "create" },
        params: {
          shop_id
        }
      });
    });
  }
  checkNewVersion(version, target) {
    const v1 = version.split(".").map(Number);
    const v2 = target.split(".").map(Number);
    for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
      const num1 = v1[i] || 0;
      const num2 = v2[i] || 0;
      if (num1 > num2)
        return true;
      if (num1 < num2)
        return false;
    }
    return false;
  }
  checkHasBrowserCore(item) {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `api://base.local/storages/preference/mainExtensionVersion`
        );
        let _version = response.data.value.version;
        const flag = this.checkNewVersion("8.8.4", _version);
        console.log(flag);
        if (flag) {
          return {
            flag: true
          };
        }
      } catch (error) {
        return {
          flag: true
        };
      }
      try {
        yield API.get(
          `api://base.local/storages/preference/browser_core_skip_check`
        );
        return {
          flag: true
        };
      } catch (error) {
      }
      try {
        const response = yield API.get(
          `api://base.auth/api/v9/shop/${item.shopOldId}/browser_core`
        );
        try {
          yield API.get(
            `api://base.local/v2/dynamic-browsers/brands/${response.data.code}/versions/${response.data.version}`
          );
          return {
            flag: true
          };
        } catch (error) {
          return {
            flag: false,
            version: response.data.version,
            code: response.data.code
          };
        }
      } catch (error) {
        return {
          flag: true
        };
      }
    });
  }
  launcher(item) {
    return __async(this, null, function* () {
      try {
        let version_response = yield API.get(`api://base.local/update/version`);
        let _version = version_response.data.version;
        if (_version !== "6.8.2.7") {
          const result = yield this.checkHasBrowserCore(item);
          if (!result.flag) {
            const version = result.version;
            const code = result.code;
            const h = this.$createElement;
            let self = this;
            this.$confirm("", this.$t("main.browser_core_tips_title"), {
              message: h("div", void 0, [
                h(
                  "div",
                  {
                    class: "text-content",
                    style: "overflow: hidden;text-overflow: ellipsis;"
                  },
                  `${this.$t("main.browser_core_tips_message", {
                    version,
                    code
                  })}`
                ),
                h(
                  "el-checkbox",
                  {
                    class: {
                      "ui-checkbox": true
                    },
                    key: Math.random(),
                    domProps: {
                      checked: self.skip_check
                    },
                    on: {
                      input: function(event) {
                        self.skip_check = event;
                      }
                    }
                  },
                  `${this.$t("main.browser_core_tips_message_skip")}`
                )
              ]),
              confirmButtonText: this.$t("main.browser_core_confirm"),
              cancelButtonText: this.$t("vdcontainer.cancel"),
              roundButton: true,
              type: "warning"
            }).then(() => __async(this, null, function* () {
              if (this.skip_check) {
                yield API.put(
                  `api://base.local/storages/preference/browser_core_skip_check`,
                  {
                    model: "browser_core_skip_check"
                  }
                );
                this.skip_check = false;
              }
              yield API.post(`api://base.local/websockets/main`, {
                model: "virtualBrowser.download.core",
                value: {
                  shop_id: item.shopOldId,
                  vd_id: item.vd_old_id,
                  new_vd: item.vd_guid,
                  new_shop_id: item.id,
                  code,
                  version
                }
              });
            })).catch((error) => {
              this.skip_check = false;
              return;
            });
            return;
          }
        }
        yield API.get(
          `api://base.local/storages/preference/mainExtensionVersion`
        );
        yield API.post(`api://base.local/websockets/main`, {
          model: "virtualBrowser.launcher_new",
          value: {
            shop_id: item.shopOldId,
            vd_id: item.vd.oldId,
            new_shop_id: item.id,
            new_vd: item.vd.id
          }
        });
      } catch (error) {
        yield API.post(`api://base.local/websockets/main`, {
          model: "virtualBrowser.launcher",
          value: {
            shop_id: item.shopOldId,
            vd_id: item.vd.oldId,
            new_shop_id: item.id,
            new_vd: item.vd.id
          }
        });
      }
    });
  }
};
__decorateClass([
  PropSync("row", {
    type: Object,
    default: function() {
      return {};
    }
  })
], StartupByShopBtn.prototype, "_row", 2);
StartupByShopBtn = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], StartupByShopBtn);
export {
  StartupByShopBtn as default
};
